import { getP } from 'redux-polyglot'
import { LOGIN_INPUT_PASSWORD, LOGIN_INPUT_USERNAME } from '../constants/login'
import api from '../libs/api'
import auth from '../libs/auth'
import { clearCartReference } from '../libs/helpers'
import { showToast } from './app'

/**
 * Actions for performing the login
 */
export const LOGIN_REQUEST = 'AUTH/LOGIN/REQUEST'
export const LOGIN_SUCCESS = 'AUTH/LOGIN/SUCCESS'
export const LOGIN_FAILURE = 'AUTH/LOGIN/FAILURE'

const loginRequest = () => ({
  type: LOGIN_REQUEST,
})

const loginSuccess = (username, apiAuthKey) => {
  auth.login(username, apiAuthKey)
  return {
    type: LOGIN_SUCCESS,
  }
}

const loginFailure = error => ({
  type: LOGIN_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  error: true,
})

export const login = (username, password) => (dispatch, getState) => {
  clearCartReference()
  dispatch(loginRequest())
  return api
    .authenticate(username, password)
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return Promise.all([
            dispatch(loginSuccess(username, response.api_auth_key)),
            dispatch(
              showToast(
                getP(getState()).t('tv_auth.logged_in_success', {
                  _: 'Successfully logged in',
                })
              )
            ),
          ])
        } else {
          return dispatch(loginFailure(response.reason))
        }
      },
      () =>
        dispatch(
          loginFailure(
            getP(getState()).t('tv_auth.error_logging_in', {
              _: 'An error occurred while logging you in',
            })
          )
        )
    )
}

/**
 * Actions related to keyboard on login screen
 */
export const FOCUS_INPUT = 'LOGIN/FOCUS_INPUT'
export const UPDATE_INPUT = 'LOGIN/UPDATE_INPUT'
export const DELETE_INPUT = 'LOGIN/DELETE_INPUT'
export const ERROR_INPUT = 'LOGIN/ERROR_INPUT'
export const SET_STATUS = 'LOGIN/SET_STATUS'
export const FOCUS_KEYBOARD = 'LOGIN/FOCUS_KEYBOARD'

export const focusInput = focusedInput => {
  let newFocusedInput
  switch (focusedInput) {
    case LOGIN_INPUT_USERNAME:
    case LOGIN_INPUT_PASSWORD:
      newFocusedInput = focusedInput
      break
    default:
      newFocusedInput = LOGIN_INPUT_USERNAME
  }

  return {
    type: FOCUS_INPUT,
    payload: {
      focusedInput: newFocusedInput,
    },
  }
}

export const updateInput = newKey => ({
  type: UPDATE_INPUT,
  payload: {
    newKey,
  },
})

export const deleteInput = () => ({
  type: DELETE_INPUT,
})

export const errorInput = (input, error) => ({
  type: ERROR_INPUT,
  payload: {
    input,
    error,
  },
})

export const setStatus = status => ({
  type: SET_STATUS,
  payload: {
    status,
  },
})

export const focusKeyboard = focus => ({
  type: FOCUS_KEYBOARD,
  payload: {
    focus,
  },
})

const facebookLoginSuccess = (username, apiAuthKey) => {
  auth.login(username, apiAuthKey)
  return {
    type: LOGIN_SUCCESS,
  }
}

export const loginFacebook = (id, email) => dispatch => {
  dispatch(loginRequest())
  return api
    .postAuthenticateFacebook(id, email)
    .then(response => response.json())
    .then(response => {
      if (response.status === 200) {
        dispatch(facebookLoginSuccess(response.username, response.api_auth_key))
      } else {
        dispatch(loginFailure(response.reason))
      }
    })
    .catch(err => {
      dispatch(loginFailure(err))
    })
}
